import { Typography, Box } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import UnitsRadioGroup from "../../../Inputs/HelpDisplay/UnitsRadioGroup";
import {
  getDisbalanceUnits,
  ValueOrNull,
} from "../../../../utils/helpers/tolerance/GeneralHelper";
import { useUnits } from "../../../../hooks/useMeasureInUnits";
import { HelpOutput } from "../../../Inputs/HelpDisplay/HelpOutput";
import { toFixed } from "../../../../utils/helpers/NumberHelper";
import ResultBox from "../../../Styled/Box/ResultBox";

export default function DisbalancePerSupport({
  residualDisbalance = 0,
  residualDisbalanceByPlane = 0,
}) {
  const { t } = useTranslation();
  const disbalanceUnits = useMemo(() => getDisbalanceUnits(t), [t]);
  const { unitLabel, unit, handleUnitChange } = useUnits(
    null,
    disbalanceUnits[0]
  );

  const roundedResidualDisbalance = useMemo(
    () => ValueOrNull(toFixed(residualDisbalance * unit.value)),
    [residualDisbalance, unit.value]
  );

  const roundedResidualDisbalancePerSupport = useMemo(
    () => ValueOrNull(toFixed(residualDisbalanceByPlane * unit.value)),
    [residualDisbalanceByPlane, unit.value]
  );
  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {t("shared.disbalance.result")}
      </Typography>
      <Typography variant="h6">
        {t("units.disbalance.unitSelection")}
      </Typography>
      <UnitsRadioGroup
        value={unit}
        onChange={handleUnitChange}
        options={disbalanceUnits}
      />
      <ResultBox>
        <Typography variant="h6">
          {t(
            "pages.driveshaftTolerance.components.disbalancePerSupport.displays.disbalance.title"
          )}
        </Typography>
        <HelpOutput
          label={
            <div>
              U<sub>per</sub>, {unitLabel}
            </div>
          }
          endAdornment={unitLabel}
          helpButtonText={t(
            "pages.driveshaftTolerance.components.disbalancePerSupport.displays.disbalance.helpButtonText"
          )}
        >
          {roundedResidualDisbalance}
        </HelpOutput>
        <Typography variant="h6">
          {t(
            "pages.driveshaftTolerance.components.disbalancePerSupport.displays.disbalancePerSupport.title"
          )}
        </Typography>
        <HelpOutput
          label={
            <div>
              U'<sub>per</sub>, {unitLabel}
            </div>
          }
          endAdornment={unitLabel}
          helpButtonText={t(
            "pages.driveshaftTolerance.components.disbalancePerSupport.displays.disbalancePerSupport.helpButtonText"
          )}
        >
          {roundedResidualDisbalancePerSupport}
        </HelpOutput>
      </ResultBox>
    </Box>
  );
}
